import React, { useEffect, useState } from 'react'
import { useUserStorage } from '../../../../storage/user'
import './styles.css'

export default function MeuPerfil() {

    /* [
        { title: 'Data de cadastro', info: '-' },
        { title: 'Nome', info: '-' },
        { title: 'Sobrenome', info: '-' },
        { title: 'Usuário', info: '-' },
        { title: 'E-mail', info: '-' },
        { title: 'Número de telefone', info: '-' },
        { title: 'Profissão', info: '-' },
        { title: 'Biografia', info: '-' },
    ] */

        
    const user2 = localStorage.getItem("user")
    const user = JSON.parse(user2)

    const data = [
        { title: 'Nome', info: user.nome || '-' },
        { title: 'Data de nascimento', info: user.dataNascimento || '-' },
        { title: 'Validade da Carteirinha', info: user.validadeCarteirinha || '-' },
    ]


    return (
        <div style={{ marginLeft: '20px' }}>
            <h2 style={{ margin: '20px 0' }}>Meu perfil</h2>
            <div style={{ height: '150px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>

                {
                    data.map(item => {
                        return (
                            <div className='meuPerfilDivInputs'>
                                <h4 style={{ width: '300px' }}>{item.title}:</h4>
                                <h4>{item.info}</h4>
                            </div>
                        )
                    })
                }
            </div>

        </div>
    )
}


